//=====================================================
//　メールアドレステキストボックス
//=====================================================

import { InputTag } from "../utils/ConstCommon";
import { getMsg, ConstMsg } from "../utils/ConstMsg";
import { InputTextBase } from "./InputTextBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    name: string,
}

const FORM_TITLE = "E-mail";

export function TxtEmail(props: IFProps) {
    
    //バリデーション
    const validations = {
        required: getMsg(ConstMsg.EG0040001, [FORM_TITLE]),
        pattern: {value: /^[\w_+.-]+@[\w_+.-]+$/, message: ConstMsg.EG0040008},
        maxLength: {value: 255, message: getMsg(ConstMsg.EG0040003, [FORM_TITLE, "255"])}
    }

    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={InputTag.Required} />
            <ValidErrMsgInline name={props.name}/>
            <InputTextBase name={props.name} className="input-text-mail" placeholder="例）example@dentnet.co.jp" validations={validations} type="email"/>
        </div>
    )

}